import { isEmpty } from "@swiggy-private/js-utils";
import { STORAGE_KEYS } from "../constants";

const DEFAULT_SHOW_BACK = false;
const DEFAULT_HIDE_BOTTOM_BAR = false;
const DEFAULT_FORCE_FETCH_CONFIG = false;

/**
 * Reads a flag value: URL query param → session storage → default.
 * Returns true only when the value is the string "true".
 * Session is updated from URL in useTableConfig.
 */
const getBooleanFlag = (urlParamName: string, storageKey: string, defaultValue: boolean): boolean => {
    if (typeof window === "undefined") return defaultValue;
    try {
        const urlValue = new URLSearchParams(window.location.search).get(urlParamName);
        if (!isEmpty(urlValue)) return urlValue === "true";
        const storedValue = sessionStorage.getItem(storageKey);
        if (isEmpty(storedValue)) return defaultValue;
        return storedValue === "true";
    } catch {
        return defaultValue;
    }
};

/**
 * show_back: controls back button visibility on menu page.
 * Default: false.
 */
export const getShowBackFromStorage = (): boolean =>
    getBooleanFlag("show_back", STORAGE_KEYS.SHOW_BACK, DEFAULT_SHOW_BACK);

/**
 * hide_bottom_bar: hides the bottom bar on all screens when true.
 * Default: false.
 */
export const getHideBottomBarFromStorage = (): boolean =>
    getBooleanFlag("hide_bottom_bar", STORAGE_KEYS.HIDE_BOTTOM_BAR, DEFAULT_HIDE_BOTTOM_BAR);

/**
 * force_fetch_config: when true, forces fetchConfigFromApi in useFetchDigitalMenuConfig.
 * Default: false.
 */
export const getForceFetchConfigFromStorage = (): boolean =>
    getBooleanFlag("force_fetch_config", STORAGE_KEYS.FORCE_FETCH_CONFIG, DEFAULT_FORCE_FETCH_CONFIG);
